import { civilDate } from "@highmarch/domain";

/**
 * A Daily Road day as the Commander reads it: "Tue 13 Oct" (M39b: docs/VOICE.md has no machine dates; the domain's
 * dailyDateLabel "2026-10-13" stays for keys and tests).
 */
const WEEKDAYS = ["Thu", "Fri", "Sat", "Sun", "Mon", "Tue", "Wed"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export function dailyDayLabel(day: number): string {
  const [, m, d] = civilDate(day);
  return `${WEEKDAYS[((day % 7) + 7) % 7]} ${d} ${MONTHS[m - 1]}`;
}
